import React from 'react';
import { Container, Row, Col, Alert } from 'reactstrap';
import { LuDownload } from 'react-icons/lu';
import Loading from '../../shared/components/Loading/Loading';
import { useTikTokExport } from './hooks/useTikTokExport';
import './Integrations.css';

const TikTokIntegrationPage = () => {
  const { totalProducts, totalRows, loading, downloading, error, downloadSpreadsheet } = useTikTokExport();

  return (
    <div className="site-content">
      <div className="content-wrapper pt-6 pb-6">
        <Container fluid>
          <Row className="align-items-center mb-4">
            <Col>
              <h3 className="mb-0">TikTok Shop</h3>
              <p className="text-muted mb-0">Exporte seu catálogo no formato de importação em massa do TikTok Shop</p>
            </Col>
          </Row>

          {error && (
            <Row className="mb-4">
              <Col>
                <div className="alert alert-danger mb-0">{error}</div>
              </Col>
            </Row>
          )}

          <Row>
            <Col lg={6} className="mb-4">
              <div className="integrations-panel">
                <h5>Exportar produtos</h5>
                <p className="text-muted mb-1">
                  Gera a planilha Excel no formato do template de importação em massa do TikTok Shop.
                </p>
                <p className="text-muted mb-1">
                  <strong>{totalProducts}</strong> produtos ativos
                </p>
                <p className="text-muted mb-3">
                  <strong>{totalRows}</strong> linhas serão geradas na planilha
                </p>
                <ul className="integrations-page__list">
                  <li>Uma linha por variante (cor + tamanho)</li>
                  <li>Preço normal ou com desconto conforme cadastro</li>
                  <li>Estoque atual de cada variante</li>
                  <li>Imagens e código identificador (SKU) por variante</li>
                </ul>
                <button
                  type="button"
                  className="integrations-page__download-btn"
                  onClick={downloadSpreadsheet}
                  disabled={downloading || loading}
                >
                  <LuDownload size={16} style={{ marginRight: 6, verticalAlign: -3 }} />
                  {downloading ? 'Gerando planilha...' : 'Baixar planilha (.xlsx)'}
                </button>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="integrations-panel">
                <h5>Como usar</h5>
                <ol className="integrations-page__list">
                  <li>
                    Clique em <strong>Baixar planilha</strong>
                  </li>
                  <li>
                    Acesse o <strong>TikTok Shop Seller Center</strong>
                  </li>
                  <li>
                    Vá em <strong>Produtos → Adicionar produtos → Importar em massa</strong>
                  </li>
                  <li>
                    Faça upload do arquivo <code>tiktok-produtos.xlsx</code>
                  </li>
                  <li>Revise e confirme a importação</li>
                </ol>
                <Alert color="warning" className="integrations-page__alert mb-0">
                  Preencha a coluna <strong>Categoria</strong> manualmente antes de importar — o TikTok exige a
                  categoria exata do catálogo deles.
                </Alert>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {loading && <Loading overlay />}
    </div>
  );
};

export default TikTokIntegrationPage;
